<adapt-dialog [maxWidth]="800"
              [fitHeight]="true">
    <h3 adapt-dialog-title>Schedule time with a coach</h3>

    <ng-container adapt-dialog-content>
        @if (calendlyEnabled) {
            @if (scheduled) {
                <h3>You've successfully scheduled your coaching session!</h3>
                <p>Check your email for more information.</p>
            }

            @if (!scheduled) {
                @if (!isFree) {
                    <h3>You have successfully paid for a coaching session!</h3>
                    <p>A confirmation email has been sent to you. Please select a time and date to talk with a coach below.</p>
                }
                @if (!failedToLoad) {
                    <div class="alert alert-info">
                        If you would like to schedule this another time or encounter any issues scheduling your coaching session, please
                        contact us using Intercom (the chat icon at the bottom right of your screen) or email
                        <a href="mailto:connect@theadaptway.com">connect&commat;theadaptway.com</a>.
                    </div>
                }
            }

            @if (loading) {
                <adapt-loading-spinner></adapt-loading-spinner>
            }

            @if (failedToLoad) {
                <div class="alert alert-danger">There was a problem loading our coach scheduler. Please contact us to schedule your session
                    using Intercom (the chat icon at the bottom right of your screen).</div>
            }

            @if (frameUrl) {
                <iframe [src]="frameUrl"
                        width="100%"
                        [style.height]="calendlyFrameHeight"
                        frameBorder="0"
                        title="Calendly Scheduling Page"
                        (load)="loadingUpdater.next(false)"
                        (error)="failedToLoad = true"></iframe>
            }
        } @else {
            <div class="alert alert-info">
                To schedule your coaching session, contact us using Intercom (the chat icon at the bottom right of your screen) or email
                <a href="mailto:connect@theadaptway.com">connect&commat;theadaptway.com</a>.
            </div>
        }
    </ng-container>

    <div adapt-dialog-footer
         class="ms-auto">
        <button class="btn btn-primary"
                (click)="cancel()">
            @if (!closeButtonDisabled) {
                <i class="fal fa-arrow-right me-1"></i> Return to dashboard
            } @else {
                Schedule later
            }
        </button>
    </div>
</adapt-dialog>
